import { defineWave } from '../schema';

/* ═══════════════════════════════════════════════════════════════════════════
   BLINDÉS — vitrine des forteresses.

   Une vague de démonstration pour les quatre archétypes blindés (Char, Donjon,
   Phalange, Bunker). Chacun est introduit SEUL puis laissé respirer, dans
   l'ordre où leurs leçons s'empilent : d'abord le démontage forcé (Char), puis
   le démontage négociable d'une structure fixe (Donjon), puis le contournement
   d'un porteur (Phalange), enfin la synthèse qui combine démontage ET
   contournement (Bunker). Une leçon donnée au milieu du bruit n'est pas une
   leçon — c'est la même discipline que le monde 1 impose à l'Éclat avant le
   Faucheur.

   La Phalange arrive ESCORTÉE : seule, elle n'est qu'un exercice de flanc ;
   c'est la nuée qu'elle abrite qui transforme le combat en arbitrage de cible,
   et la vitrine doit le montrer, pas seulement le décrire.

   ⚠️ Elle n'est volontairement câblée dans AUCUN niveau de la campagne. Le
   câblage d'un monde touche l'équilibrage (courbe de puissance, respirations,
   silence d'avant-boss) et relève du propriétaire du contenu de campagne, pas de
   l'ajout de ces archétypes. La vague existe pour prouver que la chaîne
   registre → levelSystem → pool → parties/bouclier tient de bout en bout ; on la
   dépose dans un niveau le jour où l'on compose le monde qui les emploie.

   ⚠️ Toutes les forteresses tiennent aux couloirs INTÉRIEURS (1 à 5) : chaque
   corps dépasse 200 PV, interdit aux couloirs de bord 0 et 6 (PLAN.md §6.11,
   vérifié par `validate`). Un blindé résistant acculé au mur ne laisse pas
   d'échappée.
   ═══════════════════════════════════════════════════════════════════════════ */

export default defineWave({
  id: 'blindes-vitrine',
  duration: 40,
  spawns: [
    // 1. CHAR — le démontage OBLIGATOIRE. Seul, au centre, pour qu'on prenne le
    //    temps de comprendre que le noyau ne s'ouvre qu'une fois les deux canons
    //    tombés, et qu'on choisisse lequel faire taire en premier.
    { at: 1.0, enemy: 'char', lane: 3, count: 1, spacing: 0 },

    // 2. DONJON — le démontage NÉGOCIABLE d'une structure ancrée. Chaque pod
    //    silencié rouvre un pan de terrain ; on lit sa route, on ouvre le pod qui
    //    la barre.
    { at: 10.0, enemy: 'donjon', lane: 3, count: 1, spacing: 0 },

    // 3. PHALANGE escortée — le contournement d'un porteur. Elle mène, l'escorte
    //    (deux Éclats légers) tire depuis son cône. Arroser de face use le
    //    bouclier ; se décaler sur le flanc règle la Phalange ET l'escorte.
    { at: 19.0, enemy: 'phalange', lane: 3, count: 1, spacing: 0 },
    { at: 20.2, enemy: 'eclat', lane: 2, count: 2, spacing: 0.6 },
    { at: 20.2, enemy: 'eclat', lane: 4, count: 2, spacing: 0.6 },

    // 4. BUNKER — la synthèse. En dernier, car il exige les deux réflexes à la
    //    suite : percer les casemates, puis contourner le cône du noyau exposé.
    { at: 30.0, enemy: 'bunker', lane: 3, count: 1, spacing: 0 },
  ],
});
